import { FlowParameterRunInfo, IExplorableItemTypeInfo } from '../../spacesPlatform/models/resourceInfoParts';
import { FlowRunError } from '../serverApi/types/FlowRunError';

export type FlowOutputStepRunListItemInfo =
  IExplorableItemTypeInfo<'flowOutputStepRun'> & FlowParameterRunInfo & FlowParameterRunInfo & {
    flowId: string;
    flowLuid: string;
    startedAt: Date; // YYYY-MM-DDThh:mm:ssZ
    completedAt: Date; // YYYY-MM-DDThh:mm:ssZ
    status: string; // FlowOutputStepRunStatus
    rowsProduced: number;
    flowRunId: string;
    backgroundJobId?: string; // background job that executed this run; the cancellation target
    flowOutputStepId: string;
    publishedDataSourceId: string;
    publishedDataSourceName: string;
    outputName: string;
    flowRunErrors: ReadonlyArray<FlowRunError>;
    runType: FlowOutputStepRunType;
    isIncremental: boolean;
    jobRetentionDays?: number;
  };

export enum FlowOutputStepRunStatus {
  pending = 'PENDING',
  inProgress = 'INPROGRESS',
  success = 'SUCCESS',
  failed = 'FAILED',
  cancelled = 'CANCELLED',
}

export enum FlowOutputStepRunType {
  scheduled = 'SCHEDULED',
  ondemand = 'ONDEMAND',
  unknown = 'UNKNOWN',
}
